module.exports = __webpack_public_path__ + "static/media/wallet_blue.8f499026.svg";